import React, { useState } from "react";
import clsx from "clsx";

import styles from "./AddShippingFee.module.scss";

import shippingFeeApi from "../../../apis/shippingFeeApi";
import ModalShippingFee from "../Modal/Modal";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
export interface AddShippingFeeProps {
  className?: string;
  dataSubmit: any;
  setDataSubmit: any;
}

const AddShippingFee = (props: AddShippingFeeProps) => {
  const { className, setDataSubmit } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [packgeType, setPackgeType] = useState<any>("");
  const [provinceCode, setProvinceCode] = useState<any>("");
  const [districtCode, setDistrictCode] = useState<any>("");
  const [wardCode, setWardCode] = useState<any>("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("tokenRESHARE");
    localStorage.removeItem("tokenHYDRA");
    localStorage.removeItem("partnerData");
    localStorage.removeItem("warehouseData");
    navigate("/login");
  };

  const addShippingFee = async (data: any) => {
    try {
      const res = await shippingFeeApi.addShippingFee(data);
      const dataRES = res?.data?.data;

      if (res?.data?.message === "Unauthenticated") {
        localStorage.clear();
        handleLogout();
      }

      if (dataRES) {
        enqueueSnackbar("Thêm thành công", { variant: "success" });
        setDataSubmit(dataRES);
        handleClose();
      } else {
        enqueueSnackbar(res.data.message, { variant: "error" });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPartnerIdFromToken = (): string => {
    return process.env.REACT_APP_ENV === "production" ? "01G486CQAV7VW2FK3DHZV1T2FG" : "01G4866BBJGYR1JH8E6RPYEW2C";
  };

  const handleFile = async (e: any) => {
    const rawWarehouseData = localStorage.getItem("warehouseData");
    const warehouseData = (rawWarehouseData && rawWarehouseData !== "undefined") ? JSON.parse(rawWarehouseData) : {};
    const partnerId = getPartnerIdFromToken();

    const file = e.target.files[0];
    if (!file) return;

    // Reset input so same file can be re-uploaded
    e.target.value = "";

    const formData = new FormData();
    formData.append("file", file);
    formData.append("serviceId", "123");
    formData.append("warehouseId", warehouseData?.id || "");
    formData.append("partnerId", partnerId);
    try {
      const res = await shippingFeeApi.importShippingFee(formData);
      const dataRES = res?.data?.data;
      if (res?.data?.code === 0 && dataRES) {
        const count = dataRES.importedCount ?? 0;
        if (count > 0) {
          enqueueSnackbar(`Thêm thành công ${count} bản ghi`, { variant: "success" });
          setDataSubmit(dataRES);
        } else {
          enqueueSnackbar("Không có bản ghi nào được thêm. Kiểm tra định dạng file CSV.", { variant: "warning" });
        }
      } else {
        enqueueSnackbar(res?.data?.message || "Lỗi không xác định", { variant: "error" });
      }
    } catch (error) {
      console.error("[AddShippingFee] import error:", error);
      enqueueSnackbar("Lỗi khi upload file", { variant: "error" });
    }
  };

  return (
    <div className={clsx(styles.root, className && className)}>
      <div className={styles.addShippingFee}>
        <div onClick={handleOpen} className={styles.addShippingFeeTitle}>
          Thêm mới thủ công
        </div>
        <div>
          <input
            className={styles.inputFile}
            id="files"
            type="file"
            onChange={(e) => {
              handleFile(e);
            }}
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>

        <ModalShippingFee
          open={open}
          handleClose={handleClose}
          setDataSubmit={setDataSubmit}
          handleSubmitModal={addShippingFee}
          packgeType={packgeType}
          setPackgeType={setPackgeType}
          provinceCode={provinceCode}
          setProvinceCode={setProvinceCode}
          districtCode={districtCode}
          setDistrictCode={setDistrictCode}
          wardCode={wardCode}
          setWardCode={setWardCode}
        />
      </div>
    </div>
  );
};

export default AddShippingFee;
